export default __webpack_public_path__ + "static/bgImageSB-b9662ec8d60a48b32f19e47cd664cecf.png";